import { Option } from 'types';
import { commonUtil, ComparisonTypes, ReportTimeframe, ReportTimeframes } from '@hone-automation/common';

export type ReportTimeframeOption = {
  value: 'Week' | 'Month' | 'Quarter' | 'Year to Date' | 'Year';
  label: string;
}[];

export const reportTimeframeOptions: ReportTimeframeOption = [
  { value: ReportTimeframes.Week, label: 'Week' },
  { value: ReportTimeframes.Month, label: 'Month' },
  { value: ReportTimeframes.Quarter, label: 'Quarter' },
  { value: ReportTimeframes.Year_to_Date, label: 'YTD' },
  { value: ReportTimeframes.Year, label: 'Year' },
];

export const reportTimeframeOptionsComparePrior: Option[] = [
  { value: ComparisonTypes.Prior_Period, label: 'Quarters' },
  { value: ComparisonTypes.Prior_Period, label: 'Weeks' },
  { value: ComparisonTypes.Prior_Period, label: 'Months' },
  { value: ComparisonTypes.Year_Over_Year, label: 'Years' },
];

export const checkboxOptionsByReport = {
  'Manager Weekly': [
    { options: 'Show Budget', isDisabled: false, isChecked: false },
    { options: 'Show Total', isChecked: false, isDisabled: false },
    { options: 'Break', isChecked: false, isDisabled: false },
    { options: 'Show YTD', isChecked: false, isDisabled: false },
  ],
  'Manager Monthly': [
    { options: 'Show Budget', isChecked: false, isDisabled: false },
    { options: 'Show Variance', isChecked: false, isDisabled: false },
    { options: 'Show YTD', isChecked: false, isDisabled: false },
  ],
  'Investor Period': [
    { options: 'Show Budget', isChecked: false, isDisabled: false },
    { options: 'Show Variance', isChecked: false, isDisabled: false },
    { options: 'Show YTD', isChecked: false, isDisabled: false },
  ],
  Custom: [
    { options: 'Show Budget', isChecked: false, isDisabled: false },
    { options: 'Show Total', isChecked: false, isDisabled: false },
    { options: 'Breakdown by Weeks/Months/Period', isChecked: false, isDisabled: false },
    { options: 'Reverse Column Order', isChecked: false, isDisabled: false },
  ],
  NoCNop: [
    { options: 'Show Budget', isChecked: false, isDisabled: false },
    { options: 'Show Variance', isChecked: false, isDisabled: false },
    { options: 'Show YTD', isChecked: false, isDisabled: false },
  ],
};
export type ReportPLDatesType = 'Custom' | 'Manager Weekly' | 'Manager Monthly' | 'Investor Period' | 'NoCNop';

export const optionsPLReports: ReportPLDatesType[] = [
  'Custom',
  'Manager Weekly',
  'Manager Monthly',
  'Investor Period',
  'NoCNop',
];

export const filterCompareOptions = (localTimeframe: ReportTimeframe) => {
  const isWeekly = localTimeframe === ReportTimeframes.Week;
  const isMonthly = localTimeframe === ReportTimeframes.Month;
  const isQuarterly = localTimeframe === ReportTimeframes.Quarter;

  if (isWeekly) {
    return reportTimeframeOptionsComparePrior.filter(ro => ro.label !== 'Months' && ro.label !== 'Quarters');
  } else if (isMonthly) {
    return reportTimeframeOptionsComparePrior.filter(ro => ro.label !== 'Weeks' && ro.label !== 'Quarters');
  } else if (isQuarterly) {
    return reportTimeframeOptionsComparePrior.filter(ro => ro.label !== 'Weeks' && ro.label !== 'Months');
  } else {
    return null;
  }
};

export const isBudgetRangeOverlapping = (
  startDate: string | undefined,
  endDate: string | undefined,
  budgetRange: { start: string; end: string } | undefined
): boolean => {
  if (!startDate || !endDate || !budgetRange) {
    return false;
  }
  return budgetRange.start <= endDate && budgetRange.end >= startDate;
};

export const emptyForFutureDate = (shortDate?: string) => {
  if (!shortDate) {
    return shortDate;
  }
  if (commonUtil.toShortString(new Date()) < shortDate) {
    return null;
  }
  return shortDate;
};
